import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { ContactsFilterApiInterface } from 'modules/mailing/email-statistics/types/email-statistics-filter-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export const useContactsByEmail = (email: string) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactsFilterApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const {
    data: contactsFilter,
    abort,
    isValidating,
  } = useControlledSwr(
    () => user && email && `${CONTACT_API}/contacts/email-list?email=${email}`,
    fetcher,
  )

  return { contactsFilter, abort, isValidating }
}
